const {log} = console
function loadGlitchSb3 (glitch) {
  return fetchArrayBuffer(`provision/glitches/${glitch.id}/${glitch.id}.sb3`)
    .then(sb3 => {
      log('loaded glitch', glitch.id)
      return Promise.resolve(sb3)
    })
}

function loadPartSb3 (part) {
  return fetchArrayBuffer(`provision/parts/${part.id}/${part.id}.sb3`)
    .then(sb3 => {
      log('loaded part', part.id)
      return Promise.resolve(sb3)
    })
}

function parseSb3 (file, vm) {
  log('parseSb3', file)
  return new Promise((resolve, reject) => {
    vm.parser(file, false, (error, data) => {
      if (error) {
        reject(error, ' on file ', file)
      } else {
        resolve({
          code: data[0],
          zip: data[1],
          sb3: file
        })
      }
    })
  })
}

function fetchArrayBuffer (path) {
  return fetch(path)
    .then(r => {
      if (r.ok) {
        return r.arrayBuffer()
      }
      throw new Error('Error fetching file', path)
    })
}

function fetchJson (path) {
  return fetch(path)
    .then(r => {
      if (r.ok) {
        return r.json()
      }
      throw new Error('Error fetching file')
    })
}

function fetchSceneSb3 (sceneId, projectMetadata) {
  const sceneToLoad = projectMetadata.scenes.find(
    s => s.id === sceneId
  )
  const sb3Path =
        `provision/projects/${projectMetadata.id}/${sceneToLoad.sb3}`
  return fetchArrayBuffer(sb3Path)
}

function fetchSceneMetadata (sceneId, projectMetadata) {
  const sceneToLoad = projectMetadata.scenes.find(
    s => s.id === sceneId
  )
  const jsonPath =
    `provision/projects/${projectMetadata.id}/${sceneToLoad.metadata}`
  return fetchJson(jsonPath)
}

module.exports = {
  fetchArrayBuffer,
  fetchJson,
  parseSb3,
  loadGlitchSb3,
  loadPartSb3,
  fetchSceneSb3,
  fetchSceneMetadata
}
